import t from"../internals/export.js";import e from"../internals/object-to-array.js";var o=t,i=e.entries;o({target:"Object",stat:!0},{entries:function(r){return i(r)}});
